var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
window.Works.InviteCoauthorModal = function (superClass) {
  extend(InviteCoauthorModal, superClass);
  function InviteCoauthorModal() {
    return InviteCoauthorModal.__super__.constructor.apply(this, arguments);
  }
  InviteCoauthorModal.prototype.className = 'bootstrap';
  InviteCoauthorModal.prototype.template = 'work_tags/templates/invite_coauthor_modal';
  InviteCoauthorModal.prototype.events = {
    'click .js-invite-coauthor-link': 'addExternalCoauthor',
    'keydown input': 'handleKeydown'
  };
  InviteCoauthorModal.prototype.initialize = function (options) {
    return this.model = new Works.CoauthorTag({
      source_details: {
        name: 'manual',
        email: 'manual'
      }
    });
  };
  InviteCoauthorModal.prototype.render = function () {
    this.$el.html(JST[this.template]());
    this.setupSelectors();
    $('body').append(this.$el);
    return this;
  };
  InviteCoauthorModal.prototype.setupSelectors = function () {
    return this.ui = {
      $modal: this.$('#coauthor-search-invite-coauthor-modal'),
      $coauthorNameInput: this.$('#add-coauthor-name'),
      $coauthorEmailInput: this.$('#add-coauthor-email'),
      $alertRow: this.$('.alert-box'),
      $alertList: this.$('.alert-list'),
      $formItems: this.$('.form-group')
    };
  };
  InviteCoauthorModal.prototype.show = function () {
    this.ui.$modal.modal('show');
    return this.ui.$coauthorNameInput.focus();
  };
  InviteCoauthorModal.prototype.handleKeydown = function (e) {
    if (e.keyCode === 13) {
      return this.addExternalCoauthor();
    }
  };
  InviteCoauthorModal.prototype.addExternalCoauthor = function () {
    this.model.set('name', this.getName());
    this.model.set('email', this.getEmail());
    if (this.model.isValid()) {
      this.collection.add(this.model);
      this.ui.$modal.modal('hide');
      return this.resetModel();
    } else {
      return this.alertValidationErrors();
    }
  };
  InviteCoauthorModal.prototype.resetModel = function () {
    this.model = new Works.CoauthorTag({
      source_details: {
        name: 'manual',
        email: 'manual'
      }
    });
    this.ui.$coauthorNameInput.val('');
    return this.ui.$coauthorEmailInput.val('');
  };
  InviteCoauthorModal.prototype.alertValidationErrors = function () {
    this.resetAlerts();
    this.insertValidationAlerts();
    return this.ui.$alertRow.fadeIn();
  };
  InviteCoauthorModal.prototype.resetAlerts = function () {
    this.ui.$alertRow.hide();
    this.ui.$formItems.removeClass('has-error');
    return this.ui.$alertList.html('');
  };
  InviteCoauthorModal.prototype.insertValidationAlerts = function () {
    _.each(this.model.validationError, function (_this) {
      return function (errorText, field) {
        var alertHtml, alertSpan;
        if (field === 'email') {
          _this.ui.$coauthorEmailInput.parent().addClass('has-error');
        } else if (field === 'name') {
          _this.ui.$coauthorNameInput.parent().addClass('has-error');
        }
        alertSpan = $('<span/>').html(errorText);
        alertHtml = $('<div/>').addClass('alert').addClass('alert-danger').attr('role', 'alert').html(alertSpan);
        return _this.ui.$alertList.append(alertHtml);
      };
    }(this));
    return this.model.unset('validationError');
  };
  InviteCoauthorModal.prototype.getName = function () {
    var inputValue, placeholder;
    placeholder = this.ui.$coauthorNameInput.attr('placeholder');
    inputValue = this.ui.$coauthorNameInput.val();
    if (placeholder === inputValue) {
      return '';
    } else {
      return inputValue;
    }
  };
  InviteCoauthorModal.prototype.getEmail = function () {
    var inputValue, placeholder;
    placeholder = this.ui.$coauthorEmailInput.attr('placeholder');
    inputValue = this.ui.$coauthorEmailInput.val();
    if (placeholder === inputValue) {
      return '';
    } else {
      return inputValue;
    }
  };
  return InviteCoauthorModal;
}(Backbone.View);
window.extend = extend;
window.hasProp = hasProp;